import { render, staticRenderFns } from "./CrudPersonalityDetails.vue?vue&type=template&id=2ca868e3&scoped=true&"
import script from "./CrudPersonalityDetails.vue?vue&type=script&lang=ts&"
export * from "./CrudPersonalityDetails.vue?vue&type=script&lang=ts&"
import style0 from "./CrudPersonalityDetails.vue?vue&type=style&index=0&id=2ca868e3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca868e3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VForm,VIcon,VRow,VTextarea})
